<template lang="pug">
.ChallengePlayerPage
  km-countdown-overlay(
    @onFinished="handleCountdownFinished"
  )
  .content

    .keyboard
      km-challenge-keyboard-input(
        :targetText="this.isReady ? targetText : ''"
        :targetPreviewText="this.isReady ? targetPreviewText : ''"
        :testRepeatCount="0"
        @onInput="handleInput"
        @onInputFinished="handleInputFinished"
      )

    //- km-minimap(
    //-   class="minimap"
    //-   :text="currentMergedText"
    //-   :playerPosition="correctCharacterIndex"
    //-   :ghostPosition="ghostCharacterIndex"
    //- )

    .footer
      .abortButton(
        v-menuHoverSound
        v-menuClickSound
        @click="handleAbortButtonClick"
      )
        font-awesome-icon.icon(icon="door-closed")
        | 検定をあきらめる
      km-remain-text-indicator(
        class="remainTextIndicator"
        :currentCount="characterCount"
        :maxCount="currentTextLength"
      )
      km-remain-time-indicator(
        class="remainTimeIndicator"
        :time="remainTime"
        :maxTime="currentTextSet.time"
      )

</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapState, mapActions } from 'vuex'
import soundService from '@/services/SoundService'
import ChallengeKeyboardInput from '@/components/shared/ChallengeKeyboardInput'
import RemainTimeIndicator from '@/components/shared/RemainTimeIndicator'
import RemainTextIndicator from '@/components/shared/RemainTextIndicator'
import Minimap from '@/components/shared/Minimap'
import CountdownOverlay from '@/components/shared/CountdownOverlay'

export default {
  name: 'challenge-player-page',
  components: {
    'km-challenge-keyboard-input': ChallengeKeyboardInput,
    'km-remain-time-indicator': RemainTimeIndicator,
    'km-remain-text-indicator': RemainTextIndicator,
    'km-minimap': Minimap,
    'km-countdown-overlay': CountdownOverlay
  },
  props: {
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isReady: false,
      ////////////////////////////
      currentTextSet: {}, // 問題
      pickedTextIndex: null,
      ////////////////////////////
      targetText: [],
      targetPreviewText: [],
      ////////////////////////////
      backspaceCount: 0,
      wrongLogs: [],
      inputText: '',
      correctCharacterIndex: null,
      score: 0,
      ////////////////////////////
      remainTime: null,
      decrementTimerInstance: null
      ////////////////////////////
      // ghostCharacterIndex: 0,
      // ghostTimerInstance: null,
    }
  },
  computed: {
    ...mapState('User', {
      challengeResult: state => state.challenge_result
    }),
    currentTextLength: function() {
      return (
        this.currentTextSet.text && this.currentTextSet.text.join('').length
      )
    },
    currentMergedText: function() {
      return this.currentTextSet.text && this.currentTextSet.text.join('')
    },
    characterCount: function() {
      return this.correctCharacterIndex
    }
  },
  /**
   * handleCountdownFinished --> start --> pickText / timerStart --> ~ --> end
   */
  methods: {
    ...mapActions('Sound', ['playBGM', 'stopBGM']),
    ...mapActions('User', ['setChallengeResult']),
    /**
     * 課題選択
     */
    async pickText() {
      const settings = await (
        await fetch('/app/static/json/settings.json', { cache: 'no-store' })
      ).json()
      const pickedIndex = Math.floor(Math.random() * settings.challenges.length)
      await fetch(
        `/app/static/json/challenge/${settings.challenges[pickedIndex]}.json`,
        { cache: 'no-store' }
      )
        .then(async response => {
          const currentTextSet = await response.json()
          this.currentTextSet = currentTextSet
          this.targetText = _.isArray(this.currentTextSet.text)
            ? this.currentTextSet.text
            : [this.currentTextSet.text]
          this.targetPreviewText = _.isArray(this.currentTextSet.previewText)
            ? this.currentTextSet.previewText
            : [this.currentTextSet.previewText]
          this.remainTime = this.currentTextSet.time
        })
        .catch(() => {
          alert('問題読み込みエラー')
          if (!this.embedded) this.$router.push('/')
        })
    },
    /**
     * 減少開始
     */
    timerStart() {
      this.decrementTimerInstance = setInterval(() => {
        this.remainTime -= 1
        if (this.remainTime === 0) {
          this.end()
        }
      }, 1000)
    },
    start() {
      this.pickText()
      this.isReady = true
      this.timerStart()
      // this.setGhost();
      soundService.play('challengeStart')
      this.playBGM('bgmChallenge')
    },
    getScore() {
      const spendTime = this.currentTextSet.time - this.remainTime
      const inputCount = this.inputText.length
      const scale = 600 / spendTime
      this.score = inputCount * scale
    },
    async end() {
      soundService.play('challengeGoal')
      soundService.stop('bgmChallenge')
      clearInterval(this.decrementTimerInstance)
      // clearInterval(this.ghostTimerInstance);
      this.getScore(this.inputText)

      const spendTime = this.currentTextSet.time - this.remainTime
      await this.setChallengeResult({
        date: moment().format('YYYY-MM-DD hh:mm'),
        spendTime,
        inputCount: this.inputText.length,
        score: this.score,
        backspaceCount: this.backspaceCount,
        wrongLogs: this.wrongLogs,
        wrongCount: this.wrongCount,
        isEmbedded: this.embedded
      })
      setTimeout(() => {
        this.$router.push(
          (this.embedded ? '/embedded' : '') + '/challenge/result'
        )
      }, 3000)
    },
    handleInput({ inputText, backspaceCount, wrongLogs, wrongCount }) {
      this.inputText = inputText
      this.correctCharacterIndex = inputText.length
      this.backspaceCount = backspaceCount
      this.wrongCount = wrongCount
      this.wrongLogs = wrongLogs
    },
    handleInputFinished({ inputText, backspaceCount, wrongLogs, wrongCount }) {
      this.inputText = inputText
      this.correctCharacterIndex = inputText.length
      this.backspaceCount = backspaceCount
      this.wrongCount = wrongCount
      this.wrongLogs = wrongLogs
      this.end()
    },
    handleCountdownFinished() {
      this.start()
    },
    handleAbortButtonClick() {
      this.$router.push((this.embedded ? '/embedded' : '') + '/challenge/')
    }
    // setGhost() {
    //   const speed = this.challengeResult.best
    //     ? this.challengeResult.best.score / 600 / 10
    //     : 0;
    //   this.ghostTimerInstance = setInterval(() => {
    //     this.ghostCharacterIndex += speed;
    //   }, 100);
    // },
  },
  mounted() {},
  beforeDestroy() {
    soundService.stop('bgmChallenge')
    clearInterval(this.decrementTimerInstance)
    // clearInterval(this.ghostTimerInstance);
  }
}
</script>

<style lang="scss" scoped>
.ChallengePlayerPage {
  height: 100%;
  width: 100%;
  background: url(../assets/bg_challenge.jpg) no-repeat;
}

.content {
  // padding: 40px;
}

.keyboard {
  position: absolute;
  width: 100%;
  height: 100%;
}

.minimap {
  position: absolute;
  top: 80px;
  right: 20px;
  margin: 20px auto;
  width: 200px;
  height: 80%;
  font-size: 1rem;
  overflow: scroll;
}

.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  width: 100%;
  height: 80px;
  background: rgba(0, 0, 0, 0.95);

  .abortButton {
    @include button;
    margin: 0 20px 0 0;
    padding: 10px 20px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    background: transparent;
    color: #fff;
    border-radius: 100px;

    &:hover {
      margin: 0;
      padding: 10px 30px;
      background: red;
    }

    .icon {
      margin-right: 10px;
    }
  }

  .remainTextIndicator {
  }

  .remainTimeIndicator {
  }
}
</style>
